import { useContext } from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import FFPaper from '../../shared/FFPaper';
import Title from '../../shared/Title';
import FFLinearProgress from '../../shared/FFLinearProgress';
import KebabMenu, { defaultMenus } from '../../shared/KebabMenu';
import { TrafficAnalyticsContext } from '../../../context/trafficanalytics-context';
import BlueSkeleton from '../../shared/BlueSkeleton';

const handler = (menu: string) => {
  console.log(menu);
}


const LoadingIndicator = () => {
  return (
    <Stack direction="column"
      spacing={4}
      sx={{
        pt: 3,
        pl: 2,
        pr: 2
      }}
    >
      <BlueSkeleton width={'100%'} sx={{ mt: 1, ml: 'auto', mr: 'auto' }} />
      <BlueSkeleton width={'100%'} sx={{ mt: 1, ml: 'auto', mr: 'auto' }} />
      <BlueSkeleton width={'100%'} sx={{ mt: 1, ml: 'auto', mr: 'auto' }} />
    </Stack>
  )
}


export default function DayHourSummaryCard() {
  const bydayinfo = 'Measures the amount of average, minimum and maximum daily traffic';
  const byhourinfo = 'Measures the amount of average, minimum and maximum traffic by the hour';
  const { status, data, isFetching } = useContext(TrafficAnalyticsContext);

  return (

    <Grid item={true} xs={12} md={12} lg={7}>
      <FFPaper
        sx={{
          position: 'relative',
          flexDirection: 'row',
        }}
      >
        <KebabMenu
          menus={defaultMenus}
          handler={handler}
        />
        <Grid container={true} spacing={1}
          sx={{
            display: 'flex',
            alignItems: 'stretch',
            position: 'relative',
            pt: 1
          }}>
          <Grid item={true} xs={6} sx={{ display: 'flex', flexDirection: 'column', position: 'relative' }}>
            <Box sx={{
              paddingLeft: 2,
            }}><Title info={bydayinfo}>By Day</Title></Box>


            {isFetching && <LoadingIndicator />}
            {status === 'success' && !isFetching &&
              <Stack direction="column"
                sx={{
                  pb: 0,
                  pr: {
                    xs: 1,
                    sm: 3,
                    md: 2,
                    lg: 4
                  },
                  pt: 2,
                  pl: {
                    xs: 1,
                    sm: 3,
                    md: 2,
                    lg: 4
                  },
                }}>

                <Stack direction="row">

                  <Box sx={{
                    flex: '1 0 30%',
                    pb: 2,
                    pr: 1
                  }}>
                    <Typography sx={{ textAlign: 'center', fontWeight: 600 }} color="secondary" fontSize={18}>
                      {data?.trafficAnalyticsByDay.value['Average Visitors'].toLocaleString()}
                    </Typography>
                    <Typography sx={{ textAlign: 'center' }} color="main" fontSize={11}>Average</Typography>
                  </Box>
                  <FFLinearProgress progressValue={14} />

                </Stack>

                <Stack direction="row">
                  <Box sx={{
                    flex: '1 0 30%',
                    pb: 1,
                    pr: 1
                  }}>
                    <Typography sx={{ textAlign: 'center', fontWeight: 600 }} color="secondary" fontSize={18}>
                      {data?.trafficAnalyticsByDay.value['Minimum Visitors'].toLocaleString()}
                    </Typography>
                    <Typography sx={{ textAlign: 'center' }} color="main" fontSize={11}>Minimum</Typography>
                  </Box>
                  <FFLinearProgress progressValue={76} />
                </Stack>

                <Stack direction="row">
                  <Box sx={{
                    flex: '1 0 30%',
                    pr: 1
                  }}>
                    <Typography sx={{ textAlign: 'center', fontWeight: 600 }} color="secondary" fontSize={18}>
                      {data?.trafficAnalyticsByDay.value['Maximum Visitors'].toLocaleString()}
                    </Typography>
                    <Typography sx={{ textAlign: 'center' }} color="main" fontSize={11}>Maximum</Typography>
                  </Box>
                  <FFLinearProgress progressValue={23} />
                </Stack>
              </Stack>
            }

          </Grid>
          <Grid item={true} xs={6} sx={{ display: 'flex', flexDirection: 'column', position: 'relative', pb: 4 }}>
            <Box ><Title info={byhourinfo}>By Hour</Title>
            </Box>

            {isFetching && <LoadingIndicator />}
            {status === 'success' && !isFetching &&

              <Stack direction="column"
                sx={{
                  pb: 0,
                  pr: {
                    xs: 1,
                    sm: 3,
                    md: 2,
                    lg: 4
                  },
                  pt: 3,
                  pl: {
                    xs: 1,
                    sm: 3,
                    md: 2,
                    lg: 4
                  },
                }}>

                <Stack direction="row">
                  <Box sx={{
                    flex: '1 0 30%',
                    pb: 1,
                    pr: 1
                  }}>
                    <Typography sx={{ textAlign: 'center', fontWeight: 600 }} color="secondary" fontSize={18}>
                      {data?.trafficAnalyticsByHour.value['Average Visitors'].toLocaleString()}
                    </Typography>
                    <Typography sx={{ textAlign: 'center' }} color="main" fontSize={11}>Average</Typography>
                  </Box>
                  <FFLinearProgress progressValue={24} />
                </Stack>

                <Stack direction="row">
                  <Box sx={{
                    flex: '1 0 30%',
                    pb: 1,
                    pr: 1
                  }}>
                    <Typography sx={{ textAlign: 'center', fontWeight: 600 }} color="secondary" fontSize={18}>
                      {data?.trafficAnalyticsByHour.value['Minimum Visitors'].toLocaleString()}
                    </Typography>
                    <Typography sx={{ textAlign: 'center' }} color="main" fontSize={11}>Minimum</Typography>
                  </Box>
                  <FFLinearProgress progressValue={76} />
                </Stack>

                <Stack direction="row">
                  <Box sx={{
                    flex: '1 0 30%',
                    pr: 1
                  }}>
                    <Typography sx={{ textAlign: 'center', fontWeight: 600 }} color="secondary" fontSize={18}>
                      {data?.trafficAnalyticsByHour.value['Maximum Visitors'].toLocaleString()}
                    </Typography>
                    <Typography sx={{ textAlign: 'center' }} color="main" fontSize={11}>Maximum</Typography>
                  </Box>
                  <FFLinearProgress progressValue={99} />
                </Stack>
              </Stack>
            }


          </Grid>

        </Grid>
      </FFPaper>
    </Grid>
  )
}